import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchAppPoemSummary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/get_app_poem_summary/`, {
    params: {
      patientId,
      trialId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};

const useGetAppPoemSummary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["app-poem-summary", patientId, trialId],
    queryFn: () => fetchAppPoemSummary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
  });
};

export default useGetAppPoemSummary;
